/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_difference_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentage Difference Calculator | Toolverse`)
};

const es_pct_difference_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Diferencia Porcentual | Toolverse`)
};

const de_pct_difference_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechner für prozentualen Unterschied | Toolverse`)
};

const nl_pct_difference_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentageverschil berekenen | Toolverse`)
};

const fr_pct_difference_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de différence en pourcentage | Toolverse`)
};

const it_pct_difference_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore di differenza percentuale | Toolverse`)
};

const pt_br2_pct_difference_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Diferença Percentual | Toolverse`)
};

const pt_pct_difference_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Diferença Percentual | Toolverse`)
};

const ja_pct_difference_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーセントの差計算機 | Toolverse`)
};

const zh_pct_difference_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`百分比差异计算器 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_difference_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_difference_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_difference_meta_title", locale)
	if (locale === "en") return en_pct_difference_meta_title(inputs)
	if (locale === "es") return es_pct_difference_meta_title(inputs)
	if (locale === "de") return de_pct_difference_meta_title(inputs)
	if (locale === "nl") return nl_pct_difference_meta_title(inputs)
	if (locale === "fr") return fr_pct_difference_meta_title(inputs)
	if (locale === "it") return it_pct_difference_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_pct_difference_meta_title(inputs)
	if (locale === "pt") return pt_pct_difference_meta_title(inputs)
	if (locale === "ja") return ja_pct_difference_meta_title(inputs)
	return zh_pct_difference_meta_title(inputs)
};